/**
 * @fileoverview Constants used throughout the application
 */

/**
 * Debounce timer value in milliseconds for onChange events
 * @constant {number}
 */
const ON_CHANGE_DEBOUNCE_TIMER = 300;

/**
 * Event names used for pub/sub communication
 * @constant {Object}
 * @property {string} cartUpdate - Event fired when cart is updated
 * @property {string} quantityUpdate - Event fired when quantity is updated
 * @property {string} variantChange - Event fired when variant changes
 * @property {string} cartError - Event fired when cart encounters an error
 * @property {string} deliveryLocationSelected - Event fired when delivery location is selected
 */
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  deliveryLocationSelected: 'delivery-location-selected',
};
